<div class="transcribe-editor-wrapper">
  <div class="editor-header">
    <div class="container">
      <div class="row">
        <div class="col-md-12 text-right">
          <!--button type="button" class="btn btn-primary save-changes-btn" [disabled]="storyboardSaving" (click)="save()"><i class="fa fa-floppy-o"></i> Save <i class="fa fa-spin fa-spinner" *ngIf="storyboardSaving"></i></button-->
          <button type="button" class="btn btn-default close-editor" (click)="close()">Close</button>
        </div>
      </div>
    </div>
  </div>
  <div class="transcribe-srt-list-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-md-12">
          <app-transcribe-sentence *ngFor="let sentence of sentences | sort:'as_milliseconds'; let i = index" [sentence]="sentence" [sentenceIndex]="i" (onDeleteSentence)="deleteSentence($event)" (onBreakSentence)="breakSentence($event)" (onOpenTextEditor)="openTextEditor($event)" (onMergeSentence)="mergeWithNext($event)"></app-transcribe-sentence>
        </div>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/storyboard/storyboard-edit/transcribe/transcribe-editor/transcribe-editor.component.html